import React from 'react';
import { Divider, Typography, Box } from '@mui/material';
import Slideshow from './Slideshow';
import FallingHearts from './FallingHearts';
import TimeElapsed from './TimeElapsed';
import YouTubeVideo from './YouTubeVideo';

const SiteContent = ({planId, imageUrls = [], startDateTime, message, videoAutoplay, videoUrl }) => {
    return (
        <>
            {imageUrls.length > 0 && <FallingHearts numHearts={10} duration={5} />}
            <Slideshow imageUrls={imageUrls} />
            <Box sx={{ px: 4}}>
                <TimeElapsed startDateTime={startDateTime} />
                <Divider sx={{ background: 'grey', maxWidth: '300px', display: 'block', mx: 'auto', mb: 4 }} />
                <Typography textAlign='center' sx={{ mb: 4 }}>
                    {message}
                </Typography>
                {planId === 'premium' && <YouTubeVideo videoUrl={videoUrl} autoplay={videoAutoplay} />}
            </Box>
        </>
    );
};

export default SiteContent;